import { Box, Skeleton, Stack } from '@mui/material';
import { Divider } from 'antd';

const FieldSkeleton = ({ multiline = false }: { multiline?: boolean }) => (
  <Box>
    <Skeleton width={80} height={18} sx={{ mb: 1 }} />
    <Skeleton variant='rounded' height={multiline ? 140 : 56} sx={{ borderRadius: '8px' }} />
  </Box>
);

const FormLoadingSkelton = () => (
  <Box display='flex' flexDirection='column' height='100%'>
    {/* Scroll Area */}
    <Box flex={1} overflow='auto' p={3}>
      <Stack spacing={3}>
        <FieldSkeleton />
        <Box>
          <FieldSkeleton multiline />
          <Skeleton width={120} height={14} sx={{ ml: 'auto', mt: 0.5 }} />
        </Box>
        <FieldSkeleton />
        <FieldSkeleton />
      </Stack>
    </Box>
    <Divider />
    <Box p={2} display='flex' justifyContent='flex-end' gap={2}>
      <Skeleton variant='rounded' width={100} height={40} />
      <Skeleton variant='rounded' width={120} height={40} />
    </Box>
  </Box>
);

export default FormLoadingSkelton;
